import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import { X } from 'lucide-react';

import { BulkActionsBar } from 'components/atoms/BulkActionsBar';
import ActionsIcon from 'pages/contactsExtended/bulkActions/actionsIcon';
import { ActionMoveToFolder } from './ActionMoveToFolder';
import { ActionDelete } from './ActionDelete';

export const ListsBulkActions = ({ selectedRows, setSelectedRows, networkId }) => (
  <BulkActionsBar
    count={selectedRows.length}
    itemLabel="list"
    sx={{ maxWidth: 'max-content', gap: '24px', zIndex: 99999 }}
    actions={
      <Flex sx={{ gap: ['0px', '0px', '24px'], cursor: 'pointer', height: '32px' }}>
        <ActionMoveToFolder selectedRows={selectedRows} networkId={networkId} onMoved={() => setSelectedRows([])} />
        <ActionDelete selectedRows={selectedRows} networkId={networkId} onDeleted={() => setSelectedRows([])} />
        <ActionsIcon onClick={() => setSelectedRows([])} icon={X} text="Clear selection" />
      </Flex>
    }
  />
);

ListsBulkActions.propTypes = {
  selectedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  networkId: PropTypes.number.isRequired,
};

export default ListsBulkActions;
